import { createEffect, onCleanup } from 'solid-js';

export function useBoundingRect(ref: HTMLElement | undefined, setter: (domRect: DOMRect) => void) {
    createEffect(() => {
        let obs: ResizeObserver | undefined = undefined;
        if (ref) {
            obs = new ResizeObserver(entries => {
                const entry = entries[0];
                if (entry) {
                    setter(entry.target.getBoundingClientRect());
                }
            });
            obs.observe(ref);
            setter(ref.getBoundingClientRect());
        }
        onCleanup(() => {
            obs?.disconnect();
        });
    });
}
